export default __webpack_public_path__ + "static/qualys-7281d1a0c6a8611e83ba72f3c2c8ef71.png";